import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';

/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-addons-tutorial-slide',
  templateUrl: 'addons-tutorial-slide.html',
})
export class AddonsTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public dishServices: DishServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_addons = true;
    this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_addons': this.globals.restaurant.tutorial_addons,
    }).then(() => {
      this.navCtrl.pop();
    });
  }

  closeLeave() {
    this.globals.restaurant.tutorial_addons = true;
    this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_addons': this.globals.restaurant.tutorial_addons,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/addons-tutorial-slide/addons-tutorial-slide.ts